import { createAction, props } from '@ngrx/store';

import { Installation, InstallationItem } from '@vi-iot/client';
import { LocationCoordinates } from './map.model';

export namespace MapActions {
  export enum Type {
    LOAD_MAP = '[MAP] Load map',
    LOAD_INSTALLATION = '[MAP] Load installation',
    LOAD_INSTALLATION_SUCCESS = '[MAP] Load installation success',
    LIST_INSTALLATIONS = '[MAP] List installations',
    LIST_INSTALLATIONS_SUCCESS = '[MAP] List installations success',
    LIST_INSTALLATIONS_ERROR = '[MAP] List installations error',
    LOAD_FIRST_THOUSAND_INSTALLATIONS = '[MAP] Load first thousand Installations',
    LOAD_FIRST_THOUSAND_INSTALLATIONS_SUCCESS = '[MAP] Load first thousand Installations Success',
    LOAD_FIRST_THOUSAND_INSTALLATIONS_ERROR = '[MAP] Load first thousand Installations Error',
    LOAD_SECOND_THOUSAND_INSTALLATIONS = '[MAP] Load second thousand Installations',
    LOAD_SECOND_THOUSAND_INSTALLATIONS_SUCCESS = '[MAP] Load second thousand Installations Success',
    LOAD_SECOND_THOUSAND_INSTALLATIONS_ERROR = '[MAP] Load second thousand Installations Error',
    LOAD_THIRD_THOUSAND_INSTALLATIONS = '[MAP] Load third thousand Installations',
    LOAD_THIRD_THOUSAND_INSTALLATIONS_SUCCESS = '[MAP] Load third thousand Installations Success',
    LOAD_THIRD_THOUSAND_INSTALLATIONS_ERROR = '[MAP] Load third thousand Installations Error',
    LIST_LOCKED_INSTALLATIONS = '[INSTALLATIONS] List Locked Installations',
    LIST_LOCKED_INSTALLATIONS_SUCCESS = '[INSTALLATIONS] List Locked Installations Success',
    LIST_LOCKED_INSTALLATIONS_ERROR = '[INSTALLATIONS] List Locked Installations Error',
    SELECT_INSTALLATION = '[MAP] Select installation',
    SELECT_INSTALLATION_SUCCESS = '[MAP] Select installation success',
    UNSELECT_INSTALLATION = '[MAP] Unselect installation',
    LOAD_MAP_SUCCESS = '[MAP] Load map success',
    LOAD_MAP_ERROR = '[MAP] Load map error',
    SEARCH_INSTALLATIONS = '[MAP] Search for installations',
    SEARCH_INSTALLATIONS_SUCCESS = '[MAP] Search for installations success',
    CLEAR_SEARCH = '[MAP] Clear search',
    FOCUS_ON_LOCATION_OF_FIRST_INSTALLATION = '[MAP] Focus on location of first installation',
  }

  export const LoadMap = createAction(Type.LOAD_MAP);

  export const selectInstallation = createAction(
    Type.SELECT_INSTALLATION,
    props<{ selectedInstallation: InstallationItem }>()
  );

  export const listInstallations = createAction(Type.LIST_INSTALLATIONS);

  export const listInstallationsSuccess = createAction(
    Type.LIST_INSTALLATIONS_SUCCESS,
    props<{ installations: InstallationItem[] }>()
  );

  export const listInstallationsError = createAction(
    Type.LIST_INSTALLATIONS_ERROR,
    props<{ error: any }>()
  );

  export const loadInstallation = createAction(
    Type.LOAD_INSTALLATION,
    props<{ installationId: number }>()
  );

  export const loadInstallationSuccess = createAction(
    Type.LOAD_INSTALLATION_SUCCESS,
    props<{ installation: InstallationItem }>()
  );

  export const loadFirstThousandInstallations = createAction(
    Type.LOAD_FIRST_THOUSAND_INSTALLATIONS
  );

  export const loadFirstThousandInstallationsSuccess = createAction(
    Type.LOAD_FIRST_THOUSAND_INSTALLATIONS_SUCCESS,
    props<{ installations: InstallationItem[]; cursor?: string }>()
  );

  export const loadFirstThousandInstallationsError = createAction(
    Type.LOAD_FIRST_THOUSAND_INSTALLATIONS_ERROR,
    props<{ error: any }>()
  );

  export const loadSecondThousandInstallations = createAction(
    Type.LOAD_SECOND_THOUSAND_INSTALLATIONS,
    props<{ cursor?: string }>()
  );

  export const loadSecondThousandInstallationsSuccess = createAction(
    Type.LOAD_SECOND_THOUSAND_INSTALLATIONS_SUCCESS,
    props<{ installations: InstallationItem[]; cursor?: string }>()
  );

  export const loadSecondThousandInstallationsError = createAction(
    Type.LOAD_SECOND_THOUSAND_INSTALLATIONS_ERROR,
    props<{ error: any }>()
  );

  export const loadThirdThousandInstallations = createAction(
    Type.LOAD_THIRD_THOUSAND_INSTALLATIONS,
    props<{ cursor?: string }>()
  );

  export const loadThirdThousandInstallationsSuccess = createAction(
    Type.LOAD_THIRD_THOUSAND_INSTALLATIONS_SUCCESS,
    props<{ installations: InstallationItem[] }>()
  );

  export const loadThirdThousandInstallationsError = createAction(
    Type.LOAD_THIRD_THOUSAND_INSTALLATIONS_ERROR,
    props<{ error: any }>()
  );

  export const listLockedInstallations = createAction(Type.LIST_LOCKED_INSTALLATIONS);

  export const listLockedInstallationsSuccess = createAction(
    Type.LIST_LOCKED_INSTALLATIONS_SUCCESS,
    props<{
      lockedInstallations: Installation[];
    }>()
  );

  export const listLockedInstallationsError = createAction(
    Type.LIST_LOCKED_INSTALLATIONS_ERROR,
    props<{ error: any }>()
  );

  export const selectInstallationSuccess = createAction(
    Type.SELECT_INSTALLATION_SUCCESS,
    props<{ selectedInstallations: InstallationItem[] }>()
  );

  export const unselectInstallation = createAction(Type.UNSELECT_INSTALLATION);

  export const loadMapSuccess = createAction(
    Type.LOAD_MAP_SUCCESS,
    props<{ installations: InstallationItem[] }>()
  );

  export const loadMapError = createAction(Type.LOAD_MAP_ERROR, props<{ error: any }>());

  export const searchInstallations = createAction(
    Type.SEARCH_INSTALLATIONS,
    props<{ searchParam: string }>()
  );

  export const clearSearch = createAction(Type.CLEAR_SEARCH);

  export const searchInstallationsSuccess = createAction(
    Type.SEARCH_INSTALLATIONS_SUCCESS,
    props<{ searchedInstallations: InstallationItem[] }>()
  );

  export const focusOnLocationOfFirstInstallation = createAction(
    Type.FOCUS_ON_LOCATION_OF_FIRST_INSTALLATION,
    props<{
      location: LocationCoordinates;
    }>()
  );
}
